import React from 'react';
import CihazSorgulamaPanel from '../components/CihazSorgulamaPanel';

const TechServiceCihazSorgulamaPage = () => (
  <main className="main-content">
    <div className="content-header">
      <h1>Cihaz Sorgulama</h1>
      <p className="content-subtitle">Seri numarası ile cihaz ve servis kayıtlarını sorgulayın</p>
    </div>
    <CihazSorgulamaPanel
      showIlRestrictionHint
      buildServisKaydiLink={(id) => `/service-records/${id}/update`}
    />
  </main>
);

export default TechServiceCihazSorgulamaPage;
